<template>
    <div class="piscreen">
    <!-- <div class="touchscreen-outer"> -->
        <!-- <div class="touchscreen"> -->
            <!-- 
            <div class="players">
                <div v-for="player in players" class="player">{{ player }}</div>
            </div>
             -->

            <!-- <div class="overlay" v-show="playerChosen"></div> -->
            <PlayerSelection v-if="!playerChosen" v-on:player-chosen="setPlayer"></PlayerSelection>
            <PlayerCreation v-if="creatingNewPlayer" v-on:player-created="playerCreated"></PlayerCreation>
            <StatusMessage v-if="statusMessage" :message="statusMessage" :category="category" :redirect="true"></StatusMessage>

            <div class="topBar">
                <div class="playerName">

                    <div class="home">
                        <a :href="'/?cat=' + category"><font-awesome-icon icon="home" /></a>
                    </div>
                    <div class="currentPlayer" @click="playerChosen = !playerChosen">
                        {{ playerName }}
                    </div>
                    <div class="createPlayer" @click="createPlayer">
                        <font-awesome-icon icon="user-plus" />
                    </div>
                </div>
            </div>


            <div v-if="category == 'singles'" class="category" id="singles">
                <header>
                    <h2>Singles</h2>
                    <p>3 darts in hetzelfde getal</p>
                </header>
            </div>

            <div v-if="category == 'doubles2x'" class="category" id="doubles2x">
                <header>
                    <h2>Doubles (2x)</h2>
                    <p>2 darts in dezelfde double</p>
                </header>
            </div>

            <div v-if="category == 'doubles3x'" class="category" id="doubles3x">
                <header>
                    <h2>Doubles (3x)</h2>
                    <p>3 darts in dezelfde double</p>
                </header>
            </div>

            <div v-if="category == 'triples2x'" class="category" id="triples2x">
                <header>
                    <h2>Triples (2x)</h2>
                    <p>2 darts in dezelfde triple</p>
                </header>
            </div>

            <div v-if="category == 'triples3x'" class="category" id="triples3x">
                <header>
                    <h2>Triples (3x)</h2>
                    <p>3 darts in dezelfde triple</p>
                </header>
            </div>

            <div v-if="category == 'shanghai'" class="category" id="shanghai">
                <header>
                    <h2>Shanghai</h2>
                    <p>Een single, double en triple in hetzelfde getal</p>
                </header>
            </div>

            <div v-if="category == 'robinhood'" class="category" id="robinhood">
                <header>
                    <h2>Robin Hood</h2>
                    <p>Gooi een dart in een getal, en dan een dart achter in de 1<sup>e</sup> dart</p>
                </header>
            </div>

            <div v-if="category == 'bull'" class="category" id="bull">
                <header>
                    <h2>Bull</h2>
                    <p>1 of meerdere darts in de bull of bullseye</p>
                </header>
            </div>

            <div class="milestones">
                
                <!-- SINGLES -->
                <table v-if="category == 'singles'">
                    <tr>
                        <td v-for="n in oneThroughTen" @click="toggleSingles(n)" v-bind:class="{ enabled: player.newSingles.includes(n), hotBorder: (player.singles.includes(n) && !player.newSingles.includes(n)) || (!player.singles.includes(n) && player.newSingles.includes(n)) }">{{ n }}</td>
                    </tr>
                    <tr>
                        <td v-for="n in elevenThroughTwenty" @click="toggleSingles(n)" v-bind:class="{ enabled: player.newSingles.includes(n), hotBorder: (player.singles.includes(n) && !player.newSingles.includes(n)) || (!player.singles.includes(n) && player.newSingles.includes(n)) }">{{ n }}</td>
                    </tr>
                </table>

                <!-- DOUBLES (2X) -->
                <table v-if="category == 'doubles2x'">
                    <tr>
                        <td v-for="n in oneThroughTen" @click="toggleDoubles2x(n)" v-bind:class="{ enabled: player.newDoubles2x.includes(n), hotBorder: (player.doubles2x.includes(n) && !player.newDoubles2x.includes(n)) || (!player.doubles2x.includes(n) && player.newDoubles2x.includes(n)) }">{{ n }}</td>
                    </tr>
                    <tr>
                        <td v-for="n in elevenThroughTwenty" @click="toggleDoubles2x(n)" v-bind:class="{ enabled: player.newDoubles2x.includes(n), hotBorder: (player.doubles2x.includes(n) && !player.newDoubles2x.includes(n)) || (!player.doubles2x.includes(n) && player.newDoubles2x.includes(n)) }">{{ n }}</td>
                    </tr>
                </table>

                <!-- DOUBLES (3X) -->
                <table v-if="category == 'doubles3x'">
                    <tr>
                        <td v-for="n in oneThroughTen" @click="toggleDoubles3x(n)" v-bind:class="{ enabled: player.newDoubles3x.includes(n), hotBorder: (player.doubles3x.includes(n) && !player.newDoubles3x.includes(n)) || (!player.doubles3x.includes(n) && player.newDoubles3x.includes(n)) }">{{ n }}</td>
                    </tr>
                    <tr>
                        <td v-for="n in elevenThroughTwenty" @click="toggleDoubles3x(n)" v-bind:class="{ enabled: player.newDoubles3x.includes(n), hotBorder: (player.doubles3x.includes(n) && !player.newDoubles3x.includes(n)) || (!player.doubles3x.includes(n) && player.newDoubles3x.includes(n)) }">{{ n }}</td>
                    </tr>
                </table>

                <!-- TRIPLES (2X) -->
                <table v-if="category == 'triples2x'">
                    <tr>
                        <td v-for="n in oneThroughTen" @click="toggleTriples2x(n)" v-bind:class="{ enabled: player.newTriples2x.includes(n), hotBorder: (player.triples2x.includes(n) && !player.newTriples2x.includes(n)) || (!player.triples2x.includes(n) && player.newTriples2x.includes(n)) }">{{ n }}</td>
                    </tr>
                    <tr>
                        <td v-for="n in elevenThroughTwenty" @click="toggleTriples2x(n)" v-bind:class="{ enabled: player.newTriples2x.includes(n), hotBorder: (player.triples2x.includes(n) && !player.newTriples2x.includes(n)) || (!player.triples2x.includes(n) && player.newTriples2x.includes(n)) }">{{ n }}</td>
                    </tr>
                </table>

                <!-- TRIPLES (3X) -->
                <table v-if="category == 'triples3x'">
                    <tr>
                        <td v-for="n in oneThroughTen" @click="toggleTriples3x(n)" v-bind:class="{ enabled: player.newTriples3x.includes(n), hotBorder: (player.triples3x.includes(n) && !player.newTriples3x.includes(n)) || (!player.triples3x.includes(n) && player.newTriples3x.includes(n)) }">{{ n }}</td>
                    </tr>
                    <tr>
                        <td v-for="n in elevenThroughTwenty" @click="toggleTriples3x(n)" v-bind:class="{ enabled: player.newTriples3x.includes(n), hotBorder: (player.triples3x.includes(n) && !player.newTriples3x.includes(n)) || (!player.triples3x.includes(n) && player.newTriples3x.includes(n)) }">{{ n }}</td>
                    </tr>
                </table>

                <!-- SHANGHAI -->
                <table v-if="category == 'shanghai'">
                    <tr>
                        <td v-for="n in oneThroughTen" @click="toggleShanghai(n)" v-bind:class="{ enabled: player.newShanghai.includes(n), hotBorder: (player.shanghai.includes(n) && !player.newShanghai.includes(n)) || (!player.shanghai.includes(n) && player.newShanghai.includes(n)) }">{{ n }}</td>
                    </tr>
                    <tr>
                        <td v-for="n in elevenThroughTwenty" @click="toggleShanghai(n)" v-bind:class="{ enabled: player.newShanghai.includes(n), hotBorder: (player.shanghai.includes(n) && !player.newShanghai.includes(n)) || (!player.shanghai.includes(n) && player.newShanghai.includes(n)) }">{{ n }}</td>
                    </tr>
                </table>

                <!-- ROBIN HOOD -->
                <table v-if="category == 'robinhood'">
                    <tr>
                        <td v-for="n in oneThroughTen" @click="toggleRobinhood(n)" v-bind:class="{ enabled: player.newRobinhood.includes(n), hotBorder: (player.robinhood.includes(n) && !player.newRobinhood.includes(n)) || (!player.robinhood.includes(n) && player.newRobinhood.includes(n)) }">{{ n }}</td>
                    </tr>
                    <tr>
                        <td v-for="n in elevenThroughTwenty" @click="toggleRobinhood(n)" v-bind:class="{ enabled: player.newRobinhood.includes(n), hotBorder: (player.robinhood.includes(n) && !player.newRobinhood.includes(n)) || (!player.robinhood.includes(n) && player.newRobinhood.includes(n)) }">{{ n }}</td>
                    </tr>
                    <tr>
                        <!-- <td @click="toggleRobinhood('bull')" v-bind:class="{ enabled: player.newRobinhood.includes('bull'), hotBorder: (player.robinhood.includes('bull') && !player.newRobinhood.includes('bull')) || (!player.robinhood.includes('bull') && player.newRobinhood.includes('bull')) }">Bull</td>
                    
                        <td @click="toggleRobinhood('bullseye')" v-bind:class="{ enabled: player.newRobinhood.includes('bullseye'), hotBorder: (player.robinhood.includes('bullseye') && !player.newRobinhood.includes('bullseye')) || (!player.robinhood.includes('bullseye') && player.newRobinhood.includes('bullseye')) }">Bulls eye</td> -->
                        <td @click="toggleRobinhood('bull')" v-bind:class="{ enabled: player.newRobinhood.includes('bull'), hotBorder: (player.robinhood.includes('bull') && !player.newRobinhood.includes('bull')) || (!player.robinhood.includes('bull') && player.newRobinhood.includes('bull')) }">
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                        </td>
                    
                        <td @click="toggleRobinhood('bullseye')" v-bind:class="{ enabled: player.newRobinhood.includes('bullseye'), hotBorder: (player.robinhood.includes('bullseye') && !player.newRobinhood.includes('bullseye')) || (!player.robinhood.includes('bullseye') && player.newRobinhood.includes('bullseye')) }">
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                        </td>
                    </tr>
                </table>

                

                <!-- BULL (1/3 -->
                <table v-if="category == 'bull'" class="bull">
                    <tr>
                        <td @click="toggleBull('G')" v-bind:class="{ enabled: player.newBull.includes('G'), hotBorder: (player.bull.includes('G') && !player.newBull.includes('G')) || (!player.bull.includes('G') && player.newBull.includes('G')) }">
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                        </td>
                    </tr>
                    <tr>
                        <td @click="toggleBull('GG')" v-bind:class="{ enabled: player.newBull.includes('GG'), hotBorder: (player.bull.includes('GG') && !player.newBull.includes('GG')) || (!player.bull.includes('GG') && player.newBull.includes('GG')) }">
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                        </td>
                    </tr>
                    <tr>
                        <td @click="toggleBull('GGG')" v-bind:class="{ enabled: player.newBull.includes('GGG'), hotBorder: (player.bull.includes('GGG') && !player.newBull.includes('GGG')) || (!player.bull.includes('GGG') && player.newBull.includes('GGG')) }">
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                        </td>
                    </tr>
                </table>
                <!-- BULL (2/3 -->
                <table v-if="category == 'bull'" class="bull">
                    <tr>
                        <td @click="toggleBull('R')" v-bind:class="{ enabled: player.newBull.includes('R'), hotBorder: (player.bull.includes('R') && !player.newBull.includes('R')) || (!player.bull.includes('R') && player.newBull.includes('R')) }">
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                        </td>
                    </tr>
                    <tr>
                        <td @click="toggleBull('RR')" v-bind:class="{ enabled: player.newBull.includes('RR'), hotBorder: (player.bull.includes('RR') && !player.newBull.includes('RR')) || (!player.bull.includes('RR') && player.newBull.includes('RR')) }">
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                        </td>
                    </tr>
                    <tr>
                        <td @click="toggleBull('RRR')" v-bind:class="{ enabled: player.newBull.includes('RRR'), hotBorder: (player.bull.includes('RRR') && !player.newBull.includes('RRR')) || (!player.bull.includes('RRR') && player.newBull.includes('RRR')) }">
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                        </td>
                    </tr>
                </table>
                <!-- BULL (3/3 -->
                <table v-if="category == 'bull'" class="bull">
                    <tr>
                        <td @click="toggleBull('GR')" v-bind:class="{ enabled: player.newBull.includes('GR'), hotBorder: (player.bull.includes('GR') && !player.newBull.includes('GR')) || (!player.bull.includes('GR') && player.newBull.includes('GR')) }">
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                        </td>
                    </tr>
                    <tr>
                        <td @click="toggleBull('GGR')" v-bind:class="{ enabled: player.newBull.includes('GGR'), hotBorder: (player.bull.includes('GGR') && !player.newBull.includes('GGR')) || (!player.bull.includes('GGR') && player.newBull.includes('GGR')) }">
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                        </td>
                    </tr>
                    <tr>
                        <td @click="toggleBull('GRR')" v-bind:class="{ enabled: player.newBull.includes('GRR'), hotBorder: (player.bull.includes('GRR') && !player.newBull.includes('GRR')) || (!player.bull.includes('GRR') && player.newBull.includes('GRR')) }">
                            <!-- BULL -->
                            <span class="bull-icon hit"><span class="bullseye-icon miss"></span></span>
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                            <!-- BULLSEYE -->
                            <span class="bull-icon miss"><span class="bullseye-icon hit"></span></span>
                        </td>
                    </tr>
                </table>




            </div>

            <div class="saveButton" @click="saveMilestones()">Save</div>

        <!-- </div> -->
        
        

    </div>

</template>

<script>

import axios from 'axios'
import PlayerSelection from './partials/PlayerSelection'
import PlayerCreation from './partials/PlayerCreation'
import StatusMessage from './partials/StatusMessage'

export default {

    name: 'EditMilestones',

    components: {
        PlayerSelection: PlayerSelection,
        PlayerCreation: PlayerCreation,
        StatusMessage: StatusMessage
    },

    data() {
        return {
            season: {
                id: 0,
                name: ''
            },
            statusMessage: '',
            playerChosen: false,
            oneThroughTen: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
            elevenThroughTwenty: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
            category: '',
            creatingNewPlayer: false,
            playerName: 'Kies een speler',
            players: [],
            player: {
                id: '',
                name: '',
                
                singles: [],
                newSingles: [],
                
                doubles2x: [],
                newDoubles2x: [],
                
                doubles3x: [],
                newDoubles3x: [],
                
                triples2x: [],
                newTriples2x: [],

                triples3x: [],
                newTriples3x: [],

                shanghai: [],
                newShanghai: [],

                robinhood: [],
                newRobinhood: [],

                bull: [],
                newBull: []
            }
        }
        
    },

    
    methods: {

        getActiveSeason() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/seasons/get_active_season.php', params).then(function (response) {
                console.log(response);
                self.season.id = response.data[0].id;
                self.season.name = response.data[0].name;
                // self.loadUsers();
            }).catch(function (error) {
                console.log(error);
            });
            
        },

        setPlayer(player) {
            this.player.id = player.id;
            this.player.name = player.name;
            this.loadMilestones(this.player.id);
            this.playerChosen = true;
            this.playerName = this.player.name;
            console.log(player.id)
        },

        createPlayer() {
            this.creatingNewPlayer = !this.creatingNewPlayer
            this.playerName = 'Nieuwe speler';
            
        },

        playerCreated() {

            this.creatingNewPlayer = false;
            this.playerChosen = false;
            this.playerName = "Kies een speler";
        },

        toggleSingles(n) {
            let index = this.player.newSingles.indexOf(n);
            if (index == -1) {
                this.player.newSingles.push(n);
            } else {
                this.player.newSingles.splice(index, 1);
            }
        },

        toggleDoubles2x(n) {
            let index = this.player.newDoubles2x.indexOf(n);
            if (index == -1) {
                this.player.newDoubles2x.push(n);
            } else {
                this.player.newDoubles2x.splice(index, 1);
            }
        },

        toggleDoubles3x(n) {
            let index = this.player.newDoubles3x.indexOf(n);
            if (index == -1) {
                this.player.newDoubles3x.push(n);
            } else {
                this.player.newDoubles3x.splice(index, 1);
            }
        },

        toggleTriples2x(n) {
            let index = this.player.newTriples2x.indexOf(n);
            if (index == -1) {
                this.player.newTriples2x.push(n);
            } else {
                this.player.newTriples2x.splice(index, 1);
            }
        },

        toggleTriples3x(n) {
            let index = this.player.newTriples3x.indexOf(n);
            if (index == -1) {
                this.player.newTriples3x.push(n);
            } else {
                this.player.newTriples3x.splice(index, 1);
            }
        },

        toggleShanghai(n) {
            let index = this.player.newShanghai.indexOf(n);
            if (index == -1) {
                this.player.newShanghai.push(n);
            } else {
                this.player.newShanghai.splice(index, 1);
            }
        },

        toggleRobinhood(n) {
            let index = this.player.newRobinhood.indexOf(n);
            if (index == -1) {
                this.player.newRobinhood.push(n);
            } else {
                this.player.newRobinhood.splice(index, 1);
            }
        },

        toggleBull(n) {
            let index = this.player.newBull.indexOf(n);
            if (index == -1) {
                this.player.newBull.push(n);
            } else {
                console.log("searching for: " + n);
                console.log("index: " + index);
                console.log("value: " + this.player.newBull[index]);
                this.player.newBull.splice(index, 1);
            }
        },



        getSingles(id) {
            this.player.singles = [];
            this.player.newSingles = [];

            const params = {
                params: {
                    user_id: id,
                    season_id: this.season.id,
                    category: 'singles'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.player.singles.push(response.data[i].score);
                    self.player.newSingles.push(response.data[i].score);
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getDoubles2x(id) {
            this.player.doubles2x = [];
            this.player.newDoubles2x = [];

            const params = {
                params: {
                    user_id: id,
                    season_id: this.season.id,
                    category: 'doubles_2x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.player.doubles2x.push(response.data[i].score);
                    self.player.newDoubles2x.push(response.data[i].score);
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getDoubles3x(id) {
            this.player.doubles3x = [];
            this.player.newDoubles3x = [];

            const params = {
                params: {
                    user_id: id,
                    season_id: this.season.id,
                    category: 'doubles_3x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.player.doubles3x.push(response.data[i].score);
                    self.player.newDoubles3x.push(response.data[i].score);
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getTriples2x(id) {
            this.player.triples2x = [];
            this.player.newTriples2x = [];

            const params = {
                params: {
                    user_id: id,
                    season_id: this.season.id,
                    category: 'triples_2x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.player.triples2x.push(response.data[i].score);
                    self.player.newTriples2x.push(response.data[i].score);
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getTriples3x(id) {
            this.player.triples3x = [];
            this.player.newTriples3x = [];

            const params = {
                params: {
                    user_id: id,
                    season_id: this.season.id,
                    category: 'triples_3x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.player.triples3x.push(response.data[i].score);
                    self.player.newTriples3x.push(response.data[i].score);
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getShanghai(id) {
            this.player.shanghai = [];
            this.player.newShanghai = [];

            const params = {
                params: {
                    user_id: id,
                    season_id: this.season.id,
                    category: 'shanghai'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.player.shanghai.push(response.data[i].score);
                    self.player.newShanghai.push(response.data[i].score);
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getRobinhood(id) {
            this.player.robinhood = [];
            this.player.newRobinhood = [];

            const params = {
                params: {
                    user_id: id,
                    season_id: this.season.id,
                    category: 'robinhood'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.player.robinhood.push(response.data[i].score);
                    self.player.newRobinhood.push(response.data[i].score);
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getBull(id) {
            this.player.bull = [];
            this.player.newBull = [];

            const params = {
                params: {
                    user_id: id,
                    season_id: this.season.id,
                    category: 'bull'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.player.bull.push(response.data[i].score);
                    self.player.newBull.push(response.data[i].score);
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },



        saveMilestones() {
            switch(this.category) {
                case "singles":
                    this.saveSingles();
                    break;
                case "doubles2x":
                    this.saveDoubles2x();
                    break;
                case "doubles3x":
                    this.saveDoubles3x();
                    break;
                case "triples2x":
                    this.saveTriples2x();
                    break;
                case "triples3x":
                    this.saveTriples3x();
                    break;
                case "shanghai":
                    this.saveShanghai();
                    break;
                case "robinhood":
                    this.saveRobinhood();
                    break;
                case "bull":
                    this.saveBull();
                    break;
                default:
                    console.warn("this is bad...");
            }
        },

        saveSingles() {
            // collect new milestones
            let add = [];
            for (let i = 0; i < this.player.newSingles.length; i++) {
                if (!this.player.singles.includes(this.player.newSingles[i])) {
                    add.push(this.player.newSingles[i]);
                }
            }

            let remove = [];
            for (let i = 0; i < this.player.singles.length; i++) {
                if (!this.player.newSingles.includes(this.player.singles[i])) {
                    remove.push(this.player.singles[i]);
                }
            }

            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('add', add);
            params.append('remove', remove);
            params.append('season_id', this.season.id);
            params.append('category', 'singles');

            let self = this;

            axios.post('/darts_db/categories/update_category.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        saveDoubles2x() {
            // collect new milestones
            let add = [];
            for (let i = 0; i < this.player.newDoubles2x.length; i++) {
                if (!this.player.doubles2x.includes(this.player.newDoubles2x[i])) {
                    add.push(this.player.newDoubles2x[i]);
                }
            }

            let remove = [];
            for (let i = 0; i < this.player.doubles2x.length; i++) {
                if (!this.player.newDoubles2x.includes(this.player.doubles2x[i])) {
                    remove.push(this.player.doubles2x[i]);
                }
            }
            
            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('add', add);
            params.append('remove', remove);
            params.append('season_id', this.season.id);
            params.append('category', 'doubles_2x');

            let self = this;

            axios.post('/darts_db/categories/update_category.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        saveDoubles3x() {
            // collect new milestones
            let add = [];
            for (let i = 0; i < this.player.newDoubles3x.length; i++) {
                if (!this.player.doubles3x.includes(this.player.newDoubles3x[i])) {
                    add.push(this.player.newDoubles3x[i]);
                }
            }

            let remove = [];
            for (let i = 0; i < this.player.doubles3x.length; i++) {
                if (!this.player.newDoubles3x.includes(this.player.doubles3x[i])) {
                    remove.push(this.player.doubles3x[i]);
                }
            }

            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('add', add);
            params.append('remove', remove);
            params.append('season_id', this.season.id);
            params.append('category', 'doubles_3x');

            let self = this;

            axios.post('/darts_db/categories/update_category.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        saveTriples2x() {
            // collect new milestones
            let add = [];
            for (let i = 0; i < this.player.newTriples2x.length; i++) {
                if (!this.player.triples2x.includes(this.player.newTriples2x[i])) {
                    add.push(this.player.newTriples2x[i]);
                }
            }

            let remove = [];
            for (let i = 0; i < this.player.triples2x.length; i++) {
                if (!this.player.newTriples2x.includes(this.player.triples2x[i])) {
                    remove.push(this.player.triples2x[i]);
                }
            }
            
            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('add', add);
            params.append('remove', remove);
            params.append('season_id', this.season.id);
            params.append('category', 'triples_2x');

            let self = this;

            axios.post('/darts_db/categories/update_category.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        saveTriples3x() {
            // collect new milestones
            let add = [];
            for (let i = 0; i < this.player.newTriples3x.length; i++) {
                if (!this.player.triples3x.includes(this.player.newTriples3x[i])) {
                    add.push(this.player.newTriples3x[i]);
                }
            }

            let remove = [];
            for (let i = 0; i < this.player.triples3x.length; i++) {
                if (!this.player.newTriples3x.includes(this.player.triples3x[i])) {
                    remove.push(this.player.triples3x[i]);
                }
            }
            
            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('add', add);
            params.append('remove', remove);
            params.append('season_id', this.season.id);
            params.append('category', 'triples_3x');

            let self = this;

            axios.post('/darts_db/categories/update_category.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        saveShanghai() {
            // collect new milestones
            let add = [];
            for (let i = 0; i < this.player.newShanghai.length; i++) {
                if (!this.player.shanghai.includes(this.player.newShanghai[i])) {
                    add.push(this.player.newShanghai[i]);
                }
            }

            let remove = [];
            for (let i = 0; i < this.player.shanghai.length; i++) {
                if (!this.player.newShanghai.includes(this.player.shanghai[i])) {
                    remove.push(this.player.shanghai[i]);
                }
            }
            
            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('add', add);
            params.append('remove', remove);
            params.append('season_id', this.season.id);
            params.append('category', 'shanghai');

            let self = this;

            axios.post('/darts_db/categories/update_category.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        saveRobinhood() {
            // collect new milestones
            let add = [];
            for (let i = 0; i < this.player.newRobinhood.length; i++) {
                if (!this.player.robinhood.includes(this.player.newRobinhood[i])) {
                    add.push(this.player.newRobinhood[i]);
                }
            }

            let remove = [];
            for (let i = 0; i < this.player.robinhood.length; i++) {
                if (!this.player.newRobinhood.includes(this.player.robinhood[i])) {
                    remove.push(this.player.robinhood[i]);
                }
            }
            
            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('add', add);
            params.append('remove', remove);
            params.append('season_id', this.season.id);
            params.append('category', 'robinhood');

            let self = this;

            axios.post('/darts_db/categories/update_category.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        saveBull() {
            // collect new milestones
            let add = [];
            for (let i = 0; i < this.player.newBull.length; i++) {
                if (!this.player.bull.includes(this.player.newBull[i])) {
                    add.push(this.player.newBull[i]);
                }
            }

            let remove = [];
            for (let i = 0; i < this.player.bull.length; i++) {
                if (!this.player.newBull.includes(this.player.bull[i])) {
                    remove.push(this.player.bull[i]);
                }
            }
            
            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('add', add);
            params.append('remove', remove);
            params.append('season_id', this.season.id);
            params.append('category', 'bull');

            let self = this;

            axios.post('/darts_db/categories/update_category.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },



        

        loadMilestones(id) {
            switch(this.category) {
                case "singles":
                    this.getSingles(id);
                    break;
                case "doubles2x":
                    this.getDoubles2x(id);
                    break;
                case "doubles3x":
                    this.getDoubles3x(id);
                    break;
                case "triples2x":
                    this.getTriples2x(id);
                    break;
                case "triples3x":
                    this.getTriples3x(id);
                    break;
                case "shanghai":
                    this.getShanghai(id);
                    break;
                case "robinhood":
                    this.getRobinhood(id);
                    break;
                case "bull":
                    this.getBull(id);
                    break;
                default:
                    console.warn("this is bad...");
            }
        }

    },



    mounted() {
        var url_string = window.location.href;
        var url = new URL(url_string);
        var cat = url.searchParams.get("cat");
        this.category = cat;
        // this.loadUsers();
        // this.loadMilestones(this.player.id);
        this.getActiveSeason();
    }
}
</script>


<style scoped>

    @font-face {
        font-family: SegoeUI;
        src: url("../../Segoe UI.ttf");
    }

    * {
        font-family: "SegoeUI";
        box-sizing: border-box;
    }
    /*html {
        overflow-x: hidden;

    }*/
    /*body {
        background: #444;
        color: #000;
        font-family: "SegoeUI";
        overflow-x: hidden;
        margin: 0;
    }*/

    .container {
        width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .touchscreen-outer {
        width: 1000px;
        height: 580px;
        display: flex;
        background: #000;
        border-radius: 10px;
    }

    .touchscreen {
        margin: auto;
        width: 800px;
        height: 480px;
        position: relative;
        background: #fff;
        /*overflow: scroll;
        overflow-x: hidden;*/
    }

    .piscreen {
        width: 800px;
    }

    /*.overlay {
        position: absolute;
        width: 800px;
        height: 390px;
        background: rgba(0,0,0,0.7);
        top: 90px;
        z-index: 10;
    }*/

    .players {
        display: flex;
        flex-wrap: wrap;
        height: 480px;
        flex-direction: column;
        justify-content: center;

    }
    .player {
        flex: 0 0 auto;
        margin: 4px;
        font-size: 32px;
        border: 1px solid #aaa;
        padding: 3px 10px;
    }

    .topBar {
        
        /*justify-content: center;*/
        /*height: 80px;*/
        background: #eee;
        /*box-shadow: 0px 1px 3px #444;*/
        /*margin-bottom: 25px;*/
        height: 90px;
        /*align-items: center;*/
        /*border-bottom: 1px solid #bbb;*/

    }
    
    .category {
        /*width: 320px;*/
        text-align: center;
        /*font-size: 32px;*/
        
        /*padding: 5px 15px 10px;*/
        /*border: 1px solid green;*/
        /*display: inline-block;*/
        /*height: 60px;*/
        /*margin: 10px 0 10px 10px;*/
        /*background: darkseagreen;*/
        margin-top: 0px;
        /*border-top: 1px solid #000;*/
        /*border-bottom: 1px solid #000;*/
        /*padding: 5px 5px 10px;*/
        text-shadow: 1px 1px 2px #000;
        background: #558b2f;
        color: white;

    }

    

    .playerName {
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
        text-align: center;
        height: 100%;
        padding: 15px;
        /*position: relative;*/
    }
        
    .home {
        position: absolute;
        font-size: 32px;
        /*border: 1px solid #558b2f;*/
        border: 1px solid #bbb;
        margin: 15px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*background: #aed581;*/
        background: #fff;
        border-radius: 3px;
        /*height: 60px;*/
        left: 0px;
        top: 0px;
        cursor: pointer;
        user-select: none;
    }
    .home a {
        text-decoration: none;
        padding: 5px 15px 10px;
        display: block;
        color: #000;
    }

    .currentPlayer {
        /*flex: 1;*/
        width: 320px;
        text-align: center;
        font-size: 32px;
        text-transform: uppercase;
        padding: 5px 15px 10px;
        /*border: 1px solid #558b2f;*/
        align-self: center;
        background: #fff;
        border: 1px solid #bbb;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*height: 60px;*/
        /*margin: 15px;*/
        /*background: #aed581;*/
        border-radius: 3px;
        margin: 0px auto;
        /*align-self: center;*/
        cursor: pointer;
        user-select: none;

    }
    .createPlayer {
        position: absolute;
        font-size: 32px;
        /*border: 1px solid #558b2f;*/
        border: 1px solid #bbb;
        margin: 15px;
        padding: 5px 15px 10px;
        /*background: #aed581;*/
        background: #fff;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        border-radius: 3px;
        /*height: 60px;*/
        right: 0px;
        top: 0px;
        cursor: pointer;
        user-select: none;
    }


    .category h2 {
        text-align: center;
        margin: 0;
        text-transform: uppercase;
    }

    .category p {
        margin: 0;
        font-size: 20px;
        text-align: center;
        /*color: black;*/
    }

    .category header {
        padding: 5px 5px 10px;
        text-shadow: 1px 1px 2px #000;
    }

    .category.easy header {
        background: #558b2f;
        margin-bottom: 1px;
        color: white;
        /*text-shadow: 1px 1px 3px #fff;*/
    }

    table {
        border-spacing: 5px;
        margin-top: 10px;
    }

    table tr {
        border: 1px solid black;
    }

    table tr td {
        font-size: 20px;
        text-align: center;
        /*padding: 5px 10px;*/
        width: 72px;
        height: 72px;
        font-weight: bold;
        cursor: pointer;
        user-select: none;
    }

    table.bull tr td {
        width: 210px;
        height: 68px;
        padding: 0 10px;


    }

    table tr td.enabled {
        background: #aed581;
        border: 1px solid #8bc34a;
    }

    table tr td:not(.enabled) {
        background: #fff;
        border: 1px solid #bbb;
    }
    
    .milestones {
        display: flex;
        justify-content: center;
    }

    .plus {

        font-size: 60px;
        line-height: 20px;
        margin-left: -10px;
    }

    .hotBorder {
        border: 4px solid #f44 !important;
        /*box-shadow: 0px 0px 3px green;*/
    }

    .saveButton {
        width: 160px;
        text-align: center;
        font-size: 32px;
        text-transform: uppercase;
        padding: 5px 15px 10px;
        /*border: 1px solid #558b2f;*/
        /*background: #aed581;*/
        background: #eee;
        border: 1px solid #bbb;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);

        border-radius: 3px;
        /*margin: 30px auto;*/
        cursor: pointer;
        user-select: none;
        position: absolute;
        top: 405px;
        left: 320px;
    }

    .bull-icon {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        display: inline-block;
        position: relative;
        border: 1px solid #444;
        margin-top: 5px;
        margin-left: 5px;
        margin-right: 5px;
        box-shadow: 0px 0px 3px #444;
    }

    .bull-icon.hit {
        background-color: #00e676;
    }

    .bull-icon.miss {
        background-color: #efe;
    }
    .bullseye-icon.miss {
        background-color: #fee;
    }

    .bullseye-icon {
        height: 24px;
        width: 24px;
        border-radius: 50%;
        position: absolute;
        display: inline-block;
        top: 11px;
        left: 11px;
        border: 1px solid #444;
    }

    .bullseye-icon.hit {
        background: #ff1744;
    }

    #singles header {
        background: #558b2f;
    }
    #doubles2x header,
    #doubles3x header {
        background: #1565c0;
    }
    #triples2x header,
    #triples3x header {
        background: #673ab7;
    }
    #shanghai header {
        background: #ad1457;
    }
    #robinhood header {
        background: #ef6c00;
    }
    #bull header {
        background: #c62828;
        color: white;
    }

    #singles + .milestones table tr td.enabled {
        background: #aed581;
        border: 1px solid #558b2f;
    }
    #doubles2x + .milestones table tr td.enabled,
    #doubles3x + .milestones table tr td.enabled {
        background: #64b5f6;
        border: 1px solid #1565c0;
    }
    #triples2x + .milestones table tr td.enabled,
    #triples3x + .milestones table tr td.enabled {
        background: #b39ddb;
        border: 1px solid #673ab7;
    }
    #shanghai + .milestones table tr td.enabled {
        background: #f06292;
        border: 1px solid #ad1457;
    }
    #robinhood + .milestones table tr td.enabled {
        background: #ffb74d;
        border: 1px solid #ef6c00;
    }
    #bull + .milestones table tr td.enabled {
        background: #e57373;
        border: 1px solid #c62828;
    }

</style>
